module.exports = __webpack_public_path__ + "img/hontai_BourgogneRed.2ed0528e.png";